import DiscordIcon from "@/components/logos/DiscordIcon";
import XIcon from "@/components/logos/XIcon";
import { brandConfig } from "@nitro-ape/shared/lib/brand-config";
import { Trans } from "@lingui/react";
import { getEnv } from "@/lib/env";

const LoginLinks = () => {
  return (
    <div className="flex flex-row items-center gap-4">
      <a
        href="/privacy"
        className="font-inter text-xs font-medium leading-[1.21] text-[#686F83] transition-colors hover:text-[#686F83]/80"
      >
        <Trans
          id="login.links.privacy"
          message="Privacy Policy"
          comment="Login footer link to the privacy policy."
        />
      </a>
      <a
        href="/terms"
        className="font-inter text-xs font-medium leading-[1.21] text-[#686F83] transition-colors hover:text-[#686F83]/80"
      >
        <Trans
          id="login.links.terms"
          message="Terms & Condition"
          comment="Login footer link to the terms and conditions."
        />
      </a>
      <a
        href={brandConfig(getEnv).xUrl}
        target="_blank"
        rel="noopener noreferrer"
        className="transition-colors hover:opacity-80"
      >
        <XIcon className="size-4 text-[#686F83]" />
      </a>
      <a
        href={brandConfig(getEnv).discordUrl}
        target="_blank"
        rel="noopener noreferrer"
        className="transition-colors hover:opacity-80"
      >
        <DiscordIcon className="size-4 text-[#686F83]" />
      </a>
    </div>
  );
};

export default LoginLinks;
